Devuelve grupos de transferencia que pueden referenciarse como destinos de transferencia en la API pública.

<ApiCodeExamples exampleId="transferGroupsList" />

<ApiResponseExamples exampleId="transferGroupsList" />

## Alcance obligatorio

- `transfer_groups.read`

## Endpoints

- `GET /public/v1/transfer-groups/`: lista paginada.
- `GET /public/v1/transfer-groups/{id}/`: detalle de un grupo de transferencia.

El detalle usa el mismo formato de campos del item de lista. Los miembros no se devuelven por defecto.

## Query parameters

- `page` (`integer`, opcional): número de página.
- `page_size` (`integer`, opcional): cantidad de items por página. Default `25`, máximo `100`.
- `search` (`string`, opcional): busca por nombre del grupo.
- `ordering` (`string`, opcional): `name`, `strategy`, `is_active`, `updated_at`, o los mismos campos con prefijo `-`.
- `transfer_eligible` (`boolean`, opcional): `true` para grupos activos con al menos un miembro elegible, `false` para grupos que no pueden recibir transferencia ahora.

## Campos de respuesta

- `id` (`uuid`): id público del grupo para `transfer_target.id`.
- `name` (`string`): nombre del grupo.
- `is_active` (`boolean`): indica si el grupo está activo.
- `transfer_eligible` (`boolean`): indica si el grupo tiene al menos un miembro activo con endpoint elegible.
- `strategy` (`string`): estrategia de distribución.
- `eligible_members_count` (`integer`): cantidad de miembros activos y elegibles.
- `updated_at` (`datetime`): fecha de última actualización.

## Referencia de opciones

- `strategy`: `rrmemory`, `leastrecent`, `fewestcalls`, `ringall`.
- `transfer_eligible=true` exige grupo activo con al menos un miembro activo y elegible.

## Errores esperados

- `401 Unauthorized`: token inválido, expirado, revocado, ausente o bloqueado por IP.
- `403 Forbidden`: la credencial no tiene `transfer_groups.read`.
- `404 Not Found`: el id del detalle no está disponible para la organización.
- `429 Too Many Requests`: rate limit de la credencial excedido.
